import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
// import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { Facebook, Instagram } from "react-feather";



const Slider = () => {
  const [sliders, setSliders] = useState([]);
  const [bestSeller, setBestSeller] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const [popularProducts, setPopularProducts] = useState([]);
  
  const [categoryitems, setcategoryitems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Best Seller
  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const response = await fetch('https://api.welbeing.in/home/bestseller/');
        const data = await response.json();
        // console.log(data.data);

        if (data.status === 'success') {
          setBestSeller(data.data);
        } else {
          setError(data.error.message || "Failed to fetch Products");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBestSellers();
  }, []);


  // NewArrivals

  useEffect(() => {
    const fetchNewArrivals = async () => {

      try {
        const response = await fetch('https://api.welbeing.in/home/new-arrival/');
        const data = await response.json();

        if (data.status === 'success') {
          setNewArrivals(data.data);
        } else {
          setError(data.error.message || "Failed to fetch new arrivals");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchNewArrivals();
  }, []);


  // Popular Products
  useEffect(() => {
    const fetchPopularProducts = async () => {

      try {
        const response = await fetch('https://api.welbeing.in/home/popular-product/');
        const data = await response.json();

        if (data.status === 'success') {
          setPopularProducts(data.data);
        } else {
          setError(data.error.message || "Failed to fetch new arrivals");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPopularProducts();
  }, []);



  // category Products
  useEffect(() => {
    const fetchcategory = async () => {

      try {
        const response = await fetch('https://api.welbeing.in/admin/home/categoryproduct/');
        const data = await response.json();
        // console.log(data.data);

        if (data.status === 'success') {
          setcategoryitems(data.data);
        } else {
          setError(data.error.message || "Failed to fetch new arrivals");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchcategory();
  }, []);

  const groupedProducts = categoryitems.reduce((acc, product) => {
  if (!acc[product.cat]) {
    acc[product.cat] = [];
  }
  acc[product.cat].push(product);
  return acc;
}, {});

const categories = Object.keys(groupedProducts);
// console.log(categories);


  return (
    <main className="main">


      {/* Sub Banner Section End */}

      {/* <section className="sub-banner-5">
        <div className="container-lg">
          <div className="banner" style={{ position: "relative", overflow: "hidden" }}> */}
            {/* <img
              className="img-fluid"
              src="assets/img/banner/sub-banner2.jpg"
              alt="Welbeing"
              loading="lazy"
              style={{ width: "100%", height: "500px", objectFit: "cover", display: "block" }}
            /> */}

            {/* Dark overlay */}
            {/* <div style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0, 0, 0, 0.35)",
              zIndex: 1
            }}></div> */}

            {/* <div className="content-box" style={{
              position: "absolute",
              top: "50%",
              left: "5%",
              transform: "translateY(-50%)",
              zIndex: 2,
              maxWidth: "500px"
            }}>
              <h5 className="title-banner text-white">
                <span className="after text-white">modern</span>BAGS
                <span className="offer">
                  20 <span><span className="span-1">%</span><span className="span-2">OFF</span></span>
                </span>
              </h5>
              <h6 className="collection-title">
                <span className="line text-white"></span> New Collections
              </h6>
              <p className="text-white">
                Best offer on new collection bags visit now before late, best value
                for money on buying any product above ₹999.00
              </p>

              <div className="btn-box">
                <div className="btn-style4">
                  <a href="/shop" className="btn">
                    <span className="corner-wrap left-top">
                      <span className="corner"></span>
                    </span>
                    <span className="corner-wrap right-bottom">
                      <span className="corner"></span>
                    </span>
                    Shop Now
                  </a>
                </div>
                <div className="contact-info">
                  <a className="phone-link text-white" href="tel:+919047473959">
                    <img
                      src="assets/img/icons/phone-book.svg"
                      alt="phone-book"
                      loading="lazy"
                    />
                    +91 904747 3959
                  </a>
                  <ul className="social-list">
                    <li>
                      <a href="https://www.facebook.com/welbeing.bags.gifts" target="_blank" rel="noopener noreferrer">
                        <Facebook color="white" size={20} />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/welbeing.bags.gifts/" target="_blank" rel="noopener noreferrer">
                        <Instagram color="white" size={20} />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}

          {/* </div>
        </div>
      </section> */}
      {/* Sub Banner Section End */}




{/* {categories.length !== 0 && (
  <>
    {categories.map((catName, index) => (
      <section className="pb-0 ratio_asos mt-3" key={index}>
        <div className="container-lg">
          <div className="title-box">
            <h2 className="unique-heading">
              {categories.length === 1 ? "POPULAR PRODUCTS" : catName}
            </h2>

            <span className="title-divider1">
              <span className="squre"></span>
              <span className="squre"></span>
            </span>

            {categories.length === 1 && (
              <p>The best ways to change your summer wardrobe into autumn wardrobe.</p>
            )}
          </div>

          <div className="swiper-box">
            <Swiper
              modules={[Navigation]}
              spaceBetween={20}
              navigation={{
                nextEl: `.swiper-next-${index}`,
                prevEl: `.swiper-prev-${index}`,
              }}
              breakpoints={{
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                992: { slidesPerView: 4 },
              }}
              className="top-categories"
            >
              {groupedProducts[catName].map((product) => (
                <SwiperSlide key={product.p_id}>
                  <div className="intagram-card2 intagram-card">
                    <div className="img-box after-none">
                      <a href={`singleproduct?id=${product.p_id}`}>
                        <img
                          src={`https://welbeing.in/admin_panel/product_data/${product.img1}`}
                          className="img-fluid bestseller-img"
                          alt={product.name}
                          loading="lazy"
                        />
                      </a>

                      <div className="on-hover dark-box-sm">
                        <a
                          href={`singleproduct?id=${product.p_id}`}
                          className="content-box bordered-wrap"
                        >
                          <img
                            src={`https://welbeing.in/admin_panel/product_data/${product.img2}`}
                            className="img-fluid bestseller-img"
                            alt={product.name}
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="content-box mt-2" style={{ fontSize: "16px" }}>
                    <a href={`singleproduct?id=${product.p_id}`}>
                      <h5>{product.name}</h5>
                    </a>
                    <b>
                      <span>₹{product.item_price}</span> &nbsp;
                      <del style={{ color: "#911077" }}>
                        ₹
                        {parseFloat(product.item_price) +
                          Math.floor(Math.random() * 10) +
                          1}
                      </del>
                    </b>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="swiper-button">
              <button className={`swiper-next-${index}`}>
                <i data-feather="arrow-left"></i>
              </button>
              <button className={`swiper-prev-${index}`}>
                <i data-feather="arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
    ))}
  </>
)} */}


      {/* Best Sellers */}
      {bestSeller?.length >= 5 && (
        <section className="pb-0 ratio_asos mt-3">
          <div class="container-lg">
            <div class="title-box">
              <h2 class="unique-heading">BEST SELLERS</h2>
              <span class="title-divider1"><span class="squre"></span><span class="squre"></span></span>
              <p>Shop Our Most-loved Products, Popular Bags, and Favorite Gift Items!</p>
            </div>

            <div class="swiper-box">
              <Swiper modules={[Navigation]} spaceBetween={20} navigation={{ nextEl: '.swiper-next', prevEl: '.swiper-prev', }}
                breakpoints={{
                  576: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  992: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 6,
                  },
                }}
                className="top-categories">
                {bestSeller?.map((product) => (
                  <SwiperSlide key={product.p_id}>
                    <div className='border-lg' style={{border: '1px solid #fff'}} >
                      <div className="intagram-card2 intagram-card">
                        <div className="img-box after-none border-lg">
                          <a href={`singleproduct?id=${product.p_id}`}><img src={`https://welbeing.in/admin_panel/product_data/${product.img1}`} className="img-fluid bestseller-img" alt={product.item_name} loading="lazy" /></a>
                          <div className="on-hover dark-box-sm">
                            <a href={`singleproduct?id=${product.p_id}`} className="content-box bordered-wrap"><img src="" className="img-fluid" alt={product.item_name} loading="lazy" /></a>
                          </div>
                        </div>
                      </div>
                      <div className="content-box mt-2" style={{ fontSize: '16px', padding: '0px 10px' }}>
                        <a href={`singleproduct?id=${product.p_id}`}><h5>{product.item_name?.length > 22 ? product.item_name.slice(0, 22) + "..." : product.item_name}</h5></a>
                        <b className='mt-2 mb-2' style={{display: 'flex', justifyContent: 'space-between'}}>
                          <del style={{ color: '#911077', paddingTop: '5px' }}> ₹{parseFloat(product.item_price) + Math.floor(Math.random() * 10) + 1}</del>
                          <span style={{fontSize: '20px'}}>₹{Number(product.item_price).toFixed(2)}</span>
                        </b>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div class="swiper-button">
                <button class="swiper-next">
                  <i className='fa fa-arrow-left'></i>
                </button>
                <button class="swiper-prev"><i className='fa fa-arrow-right'></i></button>
              </div>
            </div>
          </div>
        </section>
      )}
      {/* Best Sellers end */}

      {/* Brand We Love Section Start */}
      {/* <section className="brand-section2 wow-section-overflow">
        <div className="container-lg">
          <div className="row g-3 g-sm-0">
            <div className="col-12">
              <div className="row g-0">
                <div className="col-sm-6">
                  <img
                    className="img-fluid"
                    src="assets/img/banner/img1.jpg"
                    alt="Welbeing"
                    loading="lazy"
                  />
                </div>
                <div className="col-sm-6">
                  <div className="brand-details bg-theme-p-side-2">
                    <div>
                      <span className="theme-color">New From True Brand</span>
                      <h3>New In this Week Your style update</h3>
                      <p>
                        Every week there are new designed bag comes,here is many designer prove theme self and give new design,this week there are served new bag design introduce explore theme all
                      </p>
                      <a href="/shop" className="btn-style2">SHOP NOW</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Brand We Love Section end */}

      {/* New Arrival */}
      {newArrivals?.length >= 6 && (
        <section className="pb-0 ratio_asos">
          <div className="container-lg">
            <div className="title-box">
              <h2 className="unique-heading">NEW ARRIVALS</h2>
              <span className="title-divider1">
                <span className="squre"></span>
                <span className="squre"></span>
              </span>
              <p>Explore our Latest Products, Stylish Bags & Delightful Gifts!</p>
            </div>

            <div className="swiper-box">
              <Swiper
                modules={[Navigation]}
                spaceBetween={20}

                navigation={{
                  nextEl: '.swiper-next',
                  prevEl: '.swiper-prev',
                }}
                breakpoints={{
                  576: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  992: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 6,
                  },
                }}
                className="top-catagories"
              >
                {newArrivals?.map((product) => (
                  <SwiperSlide key={product.p_id}>
                    <div className='border-lg' style={{border: '1px solid #fff'}} >
                      <div className="intagram-card2 intagram-card h-100">
                        <div className="img-box after-none border-lg">
                          <a href={`singleproduct?id=${product.p_id}`}>
                            <img
                              className="img-fluid"
                              src={`https://api.welbeing.in/uploads/products/${product.img2}`}
                              alt={product.item_name}
                              loading="lazy"
                            />
                          </a>
                          <div className="on-hover dark-box-sm">
                            <a
                              href={`/singleproduct?id=${product.p_id}`}
                              className="content-box bordered-wrap"
                            >
                              <img
                                className="img-fluid"
                                src={`https://api.welbeing.in/uploads/products/${product.img1}`}
                                alt={product.item_name}
                                loading="lazy"
                              />
                            </a>
                          </div>
                        </div>
                        <div className="content-box mt-2" style={{ fontSize: '16px', padding: '0px 10px' }}>
                          <a href={`/single_product.php?id=${product.p_id}`}>
                            <h5>{product.item_name?.length > 22 ? product.item_name.slice(0, 22) + "..." : product.item_name}</h5>
                            <b className='mt-2 mb-2' style={{display: 'flex', justifyContent: 'space-between'}}>
                              <del style={{ color: '#911077', paddingTop: '5px' }}> ₹{parseFloat(product.item_price) + Math.floor(Math.random() * 10) + 1}</del>
                              <span style={{fontSize: '20px'}}>₹{Number(product.item_price).toFixed(2)}</span>
                            </b>
                          </a>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="swiper-button">
                <button className="swiper-prev">
                  <i className='fa fa-arrow-right'></i>
                </button>
                <button className="swiper-next">
                  <i className='fa fa-arrow-left'></i>
                </button>
              </div>
            </div>
          </div>
        </section>
      )}
      {/* New Arrival end */}



      {/* Brand We Love Section Start */}
      {/* <section className="brand-section2 pb-0 wow-section-overflow">
        <div className="container-lg">
          <div className="row g-3 g-sm-0">
            <div className="col-12">
              <div className="row g-0">
                <div className="order-4 order-sm-3 col-sm-6">
                  <div className="brand-details bg-theme-p-side-2">
                    <div>
                      <span className="theme-color">Get Set, Go!</span>
                      <h3>made by professionals for you</h3>
                      <p>
                        Many professionals designer are give there Creative idea ,here are some of design are popular quickly to market for there Unique design and creative ideas, here are there
                        collection for sell
                      </p>
                      <a href="/shop" className="btn-style2">SHOP NOW</a>
                    </div>
                  </div>
                </div>

                <div className="order-3 order-sm-4 col-sm-6">
                  <img
                    className="img-fluid"
                    src="assets/img/banner/img2.jpg"
                    alt="Welbeing"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Brand We Love Section end */}

      {/* {popularProducts.length !== 0 ? (
        <section class="pb-0 ratio_asos mt-3">
          <div class="container-lg">
            <div class="title-box">
              <h2 class="unique-heading">POPULAR PRODUCTS</h2>
              <span class="title-divider1"><span class="squre"></span><span class="squre"></span></span>
              <p>The best ways to change your summer wardrobe into autumn wardrobe.</p>
            </div>

            <div class="swiper-box">

              <Swiper modules={[Navigation]} spaceBetween={20} navigation={{ nextEl: '.swiper-next', prevEl: '.swiper-prev', }}
                breakpoints={{
                  576: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  992: {
                    slidesPerView: 4,
                  },
                }}
                className="top-categories">
                {popularProducts?.map((product) => (
                  <SwiperSlide key={product.p_id}>
                    <div className="intagram-card2 intagram-card">
                      <div className="img-box after-none">
                        <a href={`singleproduct?id=${product.p_id}`}><img src={`https://welbeing.in/admin_panel/product_data/${product.img1}`} className="img-fluid bestseller-img" alt={product.name} loading="lazy" /></a>
                        <div className="on-hover dark-box-sm">
                          <a href={`singleproduct?id=${product.p_id}`} className="content-box bordered-wrap"><img src={`https://welbeing.in/admin_panel/product_data/${product.img2}`} className="img-fluid  bestseller-img" alt={product.name} loading="lazy" /></a>
                        </div>
                      </div>
                    </div>
                    <div className="content-box mt-2" style={{ fontSize: '16px' }}>
                      <a href={`singleproduct?id=${product.p_id}`}><h5>{product.item_name}</h5></a>
                      <b><span>₹{product.item_price}</span> &nbsp;<del style={{ color: '#911077' }}><del style={{ color: '#911077' }}> ₹{parseFloat(product.item_price) + Math.floor(Math.random() * 10) + 1}</del></del></b>
                    </div>

                  </SwiperSlide>
                ))}
              </Swiper>

              <div class="swiper-button">
                <button class="swiper-next">
                  <i data-feather="arrow-left"></i>
                </button>
                <button class="swiper-prev"><i data-feather="arrow-right"></i></button>
              </div>
            </div>
          </div>
        </section>
      ) : (<></>)} */}

      {/* Detail Card Section Start */}
      {/* <section className="detail-card-section ratio_asos pb-0 wow-section-overflow">
        <div className="container-lg">
          <div className="row gy-4 g-2 g-sm-3 g-xl-4">
            <div className="col-12 col-md-3 col-lg-3 span3 wow fadeInUp" data-wow-delay="0.3s">
              <div className="detail-card">
                <div className="img-wrap">
                  <img
                    className="img-fluid"
                    src="assets/img/banner/img3.jpg"
                    alt="Welbeing"
                    loading="lazy"
                  />
                </div>
                <div className="content-box">
                  <h3>Gift Box</h3>
                  <p>Unwrap joy with our curated gift boxes to delight your loved ones.</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-3 col-lg-3 span3 wow fadeInUp" data-wow-delay="0.4s">
              <div className="detail-card">
                <div className="img-wrap">
                  <img
                    className="img-fluid"
                    src="assets/img/banner/img4.jpg"
                    alt="Welbeing"
                    loading="lazy"
                  />
                </div>
                <div className="content-box">
                  <h3>Gift Box</h3>
                  <p>showcasing a harmonious blend of luxury and sustainability.</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-3 col-lg-3 span3 wow fadeInUp" data-wow-delay="0.5s">
              <div className="detail-card">
                <div className="img-wrap">
                  <img
                    className="img-fluid"
                    src="assets/img/banner/img5.jpg"
                    alt="Welbeing"
                    loading="lazy"
                  />
                </div>
                <div className="content-box">
                  <h3>Gift Box</h3>
                  <p>Give the gift of joy while honoring the planet with our carefully curated selections.</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-3 col-lg-3 span3 wow fadeInUp" data-wow-delay="0.6s">
              <div className="detail-card">
                <div className="img-wrap">
                  <img
                    className="img-fluid"
                    src="assets/img/banner/img6.jpg"
                    alt="Welbeing"
                    loading="lazy"
                  />
                </div>
                <div className="content-box">
                  <h3>Gift Box</h3>
                  <p>Elevate the art of gifting with our exquisite gift boxes.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Detail Card Section End */}

      {/* Service Section start */}
      {/* <section className="service-section service-section4 pt-0 mt-5">
        <div className="container-lg">
          <div className="banner-box">
            <img
              className="bg-img"
              src="assets/img/banner/sub-banner.jpg"
              alt="banner"
              loading="lazy"
            />

            <div className="row g-4 g-lg-0">
              <div className="col-6 col-lg-3">
                <div className="service-box">
                  <div className="media">
                    <img
                      src="assets/img/icons/truck.png"
                      height="35px"
                      alt="Free Shipping"
                      loading="lazy"
                    />
                    <div className="media-body">
                      <h5>Free Shipping</h5>
                      <span>From all orders over ₹1000</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-6 col-lg-3">
                <div className="service-box">
                  <div className="media">
                    <img
                      src="assets/img/icons/product-return.png"
                      height="40px"
                      alt="FREE RETURNS"
                      loading="lazy"
                    />
                    <div className="media-body">
                      <h5>FREE RETURNS</h5>
                      <span>Return money within 10 days</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-6 col-lg-3">
                <div className="service-box">
                  <div className="media">
                    <img
                      src="assets/img/icons/secure.png"
                      height="40px"
                      alt="SECURE SHOPPING"
                      loading="lazy"
                    />
                    <div className="media-body">
                      <h5>SECURE SHOPPING</h5>
                      <span>You're in safe hands</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-6 col-lg-3">
                <div className="service-box">
                  <div className="media">
                    <img
                      src="assets/img/icons/bulk-buying.png"
                      height="50px"
                      alt="Bulk Product"
                      loading="lazy"
                    />
                    <div className="media-body">
                      <h5>OVER 1,000 STYLES</h5>
                      <span>We have everything you need</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Service Section End */}
    </main>
  );
};

export default Slider;